class ResourceCategories {
  static TEMPLATES_TOOLS = 'Templates & Tools';
  static LEARNING_HUB = 'Learning Hub';
  static ACADEMIC_RESOURCES = 'Academic Resources';

  static OPTIONS = [
    ResourceCategories.TEMPLATES_TOOLS,
    ResourceCategories.LEARNING_HUB,
    ResourceCategories.ACADEMIC_RESOURCES,
  ];
}

export default ResourceCategories;
